"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listKeysReportConsign = void 0;
var listKeysReportConsign = exports.listKeysReportConsign = ["totalDeposit", "totalDepositGift", "totalSaleConsign", "totalSaleGiveaway", "totalReturnGift", "totalReturnOrder", "totalRemainBeforeReturn", "totalReturnConsignment"];